import DSTV from '../../pages/PayBills/SubscribeToCableTV.js';
import { BillController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { billStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import { useGetAllActiveReviews } from '../../controllers/SurveyController.js';

function DstvGotvContainer({ closeModal, setShowSurvey }) {
	const [loading, setLoading] = useState(false);
	const [pinContent, setPinContent] = useState(false);
	const [accountName, setAccountName] = useState('');

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.PAYBILLSBUYCABLETV);

	const clear = () => {
		setAccountName('');
		billStore.setCablePackages([]);
	};
	const validateCardNumber = async (cableTVCode, smartCardNo) => {
		if (cableTVCode && smartCardNo) {
			setLoading(true);
			setAccountName('');
			billStore.setCablePackages([]);
			const {
				status,
				data,
				errorMessage,
			} = await BillController.verifySmartCardNumber(cableTVCode, smartCardNo);

			if (status === constant.Success) {
				setLoading(false);
				return setAccountName(data.name);
			}
			setLoading(false);
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};


	const validationSchema = () =>
		object({
			smartCardNo: string().required('Please enter Smart Card Number'),
			package: string().required('Please select a package'),
			cableTVCode: string().required('Please select a cable TV'),
		});

	const onSubmit = async payload => {
		delete payload.packageName;
		delete payload.productCode;
		payload.controller = 'subscribeTv';
		payload.customerName = accountName;
		localStorage.setItem(constant.RouteParams, JSON.stringify(payload));
		setPinContent(true);
	};

	const goBack = () => {
		if (pinContent) {
			setPinContent(false);
		} else {
			closeModal();
		}
	};
	const cablePackages = (cableTVCode) => {
		const plans = JSON.parse(localStorage.getItem(`${cableTVCode}-packages`));
		return cableTVCode === '' ? [] : plans;
	}

	return (
		<DSTV
			pinContent={pinContent}
			validationSchema={validationSchema}
			closeModal={closeModal}
			loading={loading}
			clear={clear}
			onSubmit={onSubmit}
			cablePackages={cablePackages}
			accountName={accountName}
			validateCardNumber={validateCardNumber}
			goBack={goBack}
			setShowSurvey={setShowSurvey}
			needFeedback={needFeedback}
		/>
	);
}

export default observer(DstvGotvContainer);
